import React, { createContext, useEffect, useReducer } from 'react'
import axios from '../../../axios';
import MatxLoading from "../../components/MatxLoading";

const initialValue = {
    sellers: []
};
const reducer = (state, action) => {
    switch (action.type) {
        case 'LOAD_SELLER_DATA': {
            return {
                ...state,
                seller_list: action.payload,
            }
        }
        case 'UPDATE_SELLER_DATA': {
            let newData = state.seller_list.sellers.map((seller) =>
                action.payload.id === seller.id ? action.payload : seller
            );

            let newState = {
                sellers: newData
            }

            return {
                ...state,
                seller_list: newState,
            }
        }
        default: {
            return state
        }
    }
}

const SellerContext = createContext({
    seller_list: initialValue,
    getSeller: () => {},
    changeStatus: () => {},
    changeFeatured: () => {},
    changeProductDelivery: () => {},
})

export const SellerProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialValue)


    const changeProductDelivery = async (seller_id, status) => {

        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get(`/api/products/change_product_delivery_by_seller/${seller_id}/${status}`, options);

            return res;
        } catch (e) {
            console.error(e)
            return e;
        }
    }
    const getSeller = async () => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sellers/get_sellers', options);

            dispatch({
                type: 'LOAD_SELLER_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const changeStatus = async (seller_id, status) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sellers/change_status_seller/'+seller_id+"/"+status, options);

            dispatch({
                type: 'UPDATE_SELLER_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    const changeFeatured = async (seller_id, status) => {
        const accessToken = window.localStorage.getItem('accessToken')

        try {
            const options = {
                headers : {'Authorization': 'Bearer '+accessToken,
                    'Content-Type': 'application/x-www-form-urlencoded',
                }
            }

            const res = await axios.get('/api/sellers/change_featured_seller/'+seller_id+"/"+status, options);

            dispatch({
                type: 'UPDATE_SELLER_DATA',
                payload: res.data,
            })
        } catch (e) {
            console.error(e)
        }
    }

    useEffect(() => {
        getSeller();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    if(state.seller_list === undefined) {
        return <MatxLoading />
    }

    return (
        <SellerContext.Provider
            value={{
                seller_list: state.seller_list,
                getSeller,
                changeStatus,
                changeFeatured,
                changeProductDelivery,
            }}
        >
            {children}
        </SellerContext.Provider>
    )
}

export default SellerContext
